import mutations from "./../mutations";
import axios from 'axios'
import router from './../../router'
import uri from './../config'


const { SET_ORIGINAL_PRODUCTS, SET_NEW_GROUP, SET_NEW_PRODUCT_BY_GROUP, DELETE_PRODUCT, UPDATE_PRODUCT_TYPE } = mutations;

const accessoryStore = {
    state: {
        original_products: [],
    },
    getters: {
        get_original_products: ({ original_products }) => original_products,
        get_original_product_by_id: ({ original_products }) => _id => original_products.find(product => product._id == _id),
        

    },
    mutations: {
        [SET_ORIGINAL_PRODUCTS](state, payload) {
            state.original_products = payload;
        },
        [SET_NEW_GROUP](state, payload) {
            state.original_products.push(payload);
        },
        [SET_NEW_PRODUCT_BY_GROUP](state, payload) {
            const group = state.original_products.find(group => group._id == payload._id)
            group.products = payload.products
        },
        [UPDATE_PRODUCT_TYPE](state, payload) {
            
            state.original_products.forEach(group => {
                const product = group.products.find(product => product._id == payload.product_id)
                
                if(product)
                    product.sub_group = payload.sub_group
                
                
            })


            // state.original_products = payload;
        },
        

        [DELETE_PRODUCT](state, payload) {
            // изменяем состояние
            const group = state.original_products.find(group => group._id == payload.group_id)
            group.products = group.products.filter(acc => acc._id != payload.product_id);
        },
    },
    actions: {
        async load_original_products({ commit }) {
            console.log(12345);
            const instance = await axios.create({
                baseURL: uri,
                headers: {
                    "Content-Type": "application/json",
                    "X-token": localStorage.getItem("_token"),
                    "title": localStorage.getItem("title"),
                    "_id": localStorage.getItem("_id"),
                },
            });

            instance
                .get('/original_products')
                .then(r => r.data)
                .then(data => {
                    console.log(33333);
                    commit(SET_ORIGINAL_PRODUCTS, data.products)
                }).catch(err => {
                    console.log(err, 'err');
                    if (err.response.status == 401)
                        router.push("/statistic")
                })
        },

        

        async create_group({ commit }, data) {


            await axios
                .post(`${uri}/groups`, data)
                .then(r => r.data)
                .then(result => {

                    console.log(result.group);
                    commit(SET_NEW_GROUP, result.group)
                }).catch(err => {
                    console.log(err.message);

                })

            return { status: 'good' }
        },

        async create_product({ commit }, data) {
            
            await axios
                .post(`${uri}/original_products/${data.group_id}`, data)
                .then(r => r.data)
                .then(result => {
                    commit(SET_NEW_PRODUCT_BY_GROUP, result.group)
                })

            return { status: 'good' }
        },

        async update_sub_group({ commit }, data) {
                    console.log(data);
            const instance = await axios.create({
                baseURL: uri,
                headers: {
                    "Content-Type": "application/json",
                    "X-token": localStorage.getItem("_token"),
                    title: localStorage.getItem("title"),
                    _id: localStorage.getItem("_id"),
                },
                });
            
                instance
                .put(`/original_products/sub_group/${data.product_id}`, {sub_group : data.sub_group })
                .then(r => r.data)
                .then(result => {
                    console.log(result);
                    commit(UPDATE_PRODUCT_TYPE, {product_id: data.product_id, sub_group : data.sub_group })
                })

            return { status: 'good' }
        },

        

        async delete_product({ commit }, data) {
            return new Promise((resolve, reject) => {
                const instance = axios.create({
                    baseURL: uri,
                    headers: {
                        "Content-Type": "application/json",
                        "X-token": localStorage.getItem("_token"),
                        "title": localStorage.getItem("title"),
                        "_id": localStorage.getItem("_id"),
                    },
                });

                instance
                    .delete(`/original_products/${data._id}`)
                    .then(r => r.data)
                    .then(res => {
                        commit(DELETE_PRODUCT, { product_id: data._id, group_id: res.group_id })
                        resolve(res.message)
                    }).catch(err => {
                        reject(err.message)
                    })
            })
        }



    }
};

export default accessoryStore;